<template>
  <div>
    <nav-breadcrumb :menu="[{label: '人工还款登记'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <panel label="还款信息">
      <form-build-component
        :form-columns="repayFormColumns"
        :form-data="repayForm"
        :form-rules="repayFormRules"
        form-name="repayOfflineForm"
        ref="repayOfflineForm"
      />
      </panel>
      <panel label="客户提款信息">
        <financing-list-data-table
          v-model="customerFinancingList"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :columns="customerFinancingDataTableColumns"
        />
      </panel>
      <panel>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </panel>
    </el-row>
  </div>
</template>

<script>
  import FormBuildComponent from "../../../components/FormBuild";
  import FinancingListDataTable from '../../components/FinancingListDataTable'
  import Panel from "../../../components/Panel";
  import xhr from "../../../utils/xhr";
  import moment from 'moment'
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    label: "FinanceRepaymentRepay",
    components: {
      Panel,
      FormBuildComponent,
      FinancingListDataTable
    },
    data() {
      return {
        customerList: [],
        customerBankAccountListOptions: [],
        payBankAccountListOptions: [],
        repayForm: {
          u__customerId: '',
          u__customerCode: '',
          cj__postingAmount: '',
          cj__postingDate: moment().format('YYYY-MM-DD'),
          cj__reference: '',
          cj__remarks: '',
          cj__inboundAccountId: '',
          cj__inboundAccountDesc: '',
          cj__outboundAccountId: '',
          cj__outboundAccountDesc: '',
        },
        repayFormRules: {
          cj__postingDate: [
            {
              required: true,
              message: '交易日期不能为空'
            }
          ],
          cj__postingAmount: [
            {
              required: true,
              message: '金额不能为空'
            }
          ],
          u__customerId: [
            {
              required: true,
              message: '客户不能为空'
            }
          ],
          cj__reference: [
            {
              required: true,
              message: '流水号不能为空'
            }
          ]

        },
        page: 1,
        pageSize: 20,
        customerFinancingList: {
          page: 1,
          pageSize: 5,
          data: [],
          count: 0
        },
        customerFinancingDataTableColumns: [
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户名称',
            field: 'i__contactPerson'
          },
          {
            label: '手机号',
            field: 'i__contactTelNo'
          },
          {
            label: '贷款用途',
            field: 'fi__intendedUse'
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
          },
          {
            label: '开始日',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '到期日',
            field: 'fi__endDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '应收本金(元)',
            field: 'bal__principalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '应收利息(元)',
            field: 'bal__interestAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '本息合计(元)',
            field: 'bal__repayAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '服务费(元)',
            field: 'bal__lendingFeeAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '其它费用(元)',
            field: 'bal__otherAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '逾期罚息(元)',
            field: 'bal__overdueFine',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          }
        ]

      }
    },
    watch: {
      selectedCustomer: function (newVal) {
        this.repayForm.u__customerCode = newVal.c__customerCode
        this.getFinancingOutstandingList()
      },
      'customerFinancingList.page' : function (newVal) {
        this.getFinancingOutstandingList()
      }
    },
    computed: {
      selectedCustomer: function() {
        return this.customerList.filter(item=>item.c__customerId == this.repayForm.u__customerId).shift()
      },
      customerListOptions: function() {
        return this.customerList.map(item=>{
          return {
            label: item.c__customerName,
            value: item.c__customerId
          }
        })
      },
      repayFormColumns() {
        return [
          {
            label: '客户姓名',
            component: 'el-select',
            field: 'u__customerId',
            options: this.customerListOptions,
          },
          {
            label: '客户编号',
            field: 'u__customerCode'
          },
          {
            label: '交易日期',
            component: 'el-date-picker',
            field: 'cj__postingDate',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            label: '还款金额',
            component: 'el-input',
            unit: '元',
            field: 'cj__postingAmount'
          },
          {
            label: '流水号',
            component: 'el-input',
            field: 'cj__reference'
          },
          {
            label: '还款账户',
            component: 'el-select',
            field: 'cj__outboundAccountId',
            options: this.customerBankAccountListOptions
          },
          {
            label: '收款账户',
            component: 'el-select',
            field: 'cj__inboundAccountId',
            options: this.payBankAccountListOptions
          },
          {
            label: '摘要',
            component: 'el-input',
            type: 'textarea',
            field: 'cj__remarks',
            span: 24
          }
        ]
      }
    },
    mounted() {
      this.getCustomerList()
      this.getBankAccountList()
    },
    methods: {
      getCustomerList: function() {
        xhr.getCustomerList({
          pageSize: 1000
        },res=>{
          try{
            if(res.data.status == 'success') {
              this.customerList = res.data.data
            }
          }
          catch (e) {

          }
        })
      },
      getBankAccountList: function () {
        xhr.getBankAccountList({},res=>{
          try{
            if(res.data.status == 'success') {
              this.payBankAccountListOptions = (res.data.data||[]).map(item=>{
                return {
                  key: item['ba__accountId'],
                  label: item['ba__bank']+item['ba__branch']+item['ba__accountNo'],
                  value: item['ba__accountId']
                }
              })
            }
          }catch (e) {

          }
        })
      },
      getCustomerBankAccountList: function(customerId = this.selectedCustomer.c__customerId) {
        xhr.getCustomerBankAccountList({
            'c.customerId': customerId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.customerBankAccountListOptions = (res.data.data||[]).map(item=>{
                  return {
                    key: item['ba__accountId'],
                    label: item['ba__bank']+item['ba__branch']+item['ba__accountNo'],
                    value: item['ba__accountId']
                  }
                })
              }
            }catch (e) {

            }
          })
      },
      getFinancingOutstandingList: function (customerId= this.selectedCustomer.c__customerId) {
        xhr.getFinancingOutstandingList(
          {
            'fi.customerId' : customerId,
            pageSize: this.customerFinancingList.pageSize,
            pageOffset: (this.customerFinancingList.page - 1) * this.customerFinancingList.pageSize,
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                Object.assign(this.customerFinancingList, res.data)
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function () {
        this.$refs.repayOfflineForm.$refs.repayOfflineForm.validate(valid=>{
          if(valid) {
            xhr.updateFinancingRepayOffline(
              this.repayForm,
              res=> {
                try {
                  if(res.data.status == 'success') {
                    this.$message({
                      message: '操作成功！',
                      type: 'success'
                    })
                    this.$router.push({
                      path: '/pages/Finance/Repayment/List'
                    })
                  }
                  else {
                    this.$message({
                      message: '操作失败',
                      type: 'error'
                    })
                  }
                }catch (e) {

                }
              }
            )
          }
        })
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinanceRepaymentRepayOffline.vue